// isMobileDevice function from this blogpost: https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
// From the post:
// I found this function at StackOverFlow and I think that is brilliant. This function checks if window.orientation exists, because usually desktop computers and laptops didn't have it usually returns true on mobile devices.
// I've used it in several projects and I could say that works like a charm. However you must take into account that maybe it's not 100% reliable and some devices could give you "false" (I haven't found any problem yet).

export default function () {
  return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
}
